import { render, staticRenderFns } from "./UploadVideos.vue?vue&type=template&id=222d7309&"
import script from "./UploadVideos.vue?vue&type=script&lang=js&"
export * from "./UploadVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports